export default __webpack_public_path__ + "static/media/focus.ec6881ce.webp";